import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  width: '100%',
  minHeight: '300px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: { base: 'column', xl: 'row' },
});

export const imageContainerBaseStyles = css.raw({
  position: 'relative',
  width: '440px',
  height: '280px',
  display: 'flex',
  alignItems: 'center',
});

export const imageContainerMwebStyles = css.raw({
  position: 'relative',
  width: '100%',
  height: '300px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
